import { useEffect, useState } from 'react';
import React from 'react';
import { useDispatch } from 'react-redux';
import './App.css';
import { Provider } from 'react-redux';
import store from '../../store/index';
import { useNavigate, useLocation } from 'react-router-dom';
//import config from '../../config';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { createNavigationAction } from '../../store/navigation-slice';
import Layout from '../../components/Layout';
import { UserManager } from 'oidc-client-ts';
import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider, useMsal, useIsAuthenticated } from "@azure/msal-react";
import { msalConfig } from '../../config';

function App() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [msalInstance, setMsalInstance] = useState<PublicClientApplication | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

//  const instance = React.useMemo(() => new PublicClientApplication(msalConfig), []);
// const instance = new PublicClientApplication(msalConfig);


  useEffect(() => {
  const handleUnload = () => {
    const navEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    if (navEntry?.type !== "navigate" && navEntry?.type !== "reload") {
      localStorage.clear();
      sessionStorage.clear();
    }
  };

  window.addEventListener('unload', handleUnload);
  return () => window.removeEventListener('unload', handleUnload);
}, []);


useEffect(() => {
  const handleUnload = () => {
    const navEntry = performance.getEntriesByType("navigation")[0] as PerformanceNavigationTiming;
    if (navEntry?.type !== "navigate" && navEntry?.type !== "reload") {
      localStorage.clear();
      sessionStorage.clear();
    }
  };

  window.addEventListener('unload', handleUnload);
  return () => window.removeEventListener('unload', handleUnload);
}, []);

  
  useEffect(() => {
    const initializeMsal = async () => {
       const instance = new PublicClientApplication(msalConfig);
      await instance.initialize();
      setMsalInstance(instance);

      instance.handleRedirectPromise().then((response) => {
        if (response && response.account) {
          instance.setActiveAccount(response.account);
          sessionStorage.setItem('idToken', response.idToken);
          localStorage.setItem('isSandbox', localStorage.getItem('isSandbox') && localStorage.getItem('isSandbox') === 'true' ? 'true' : 'false');
          localStorage.setItem('activeAccountId', response.account.homeAccountId);
          setIsAuthenticated(true); // <-- Set authenticated state
           // navigate("/", { replace: true });
        } else {
          // Restore active account from cache if not set
          let activeAccount = instance.getActiveAccount();
          if (!activeAccount) {
            const accounts = instance.getAllAccounts();
            if (accounts && accounts.length > 0) {
              instance.setActiveAccount(accounts[0]);
              activeAccount = accounts[0];
            }
          }
          if (!activeAccount) {
            sessionStorage.setItem("postLoginRedirect", location.pathname + location.search);
            instance.loginRedirect({
              scopes: ["User.Read"]
            });
          } else {
            setIsAuthenticated(true); // <-- Set authenticated state
          }
        }
      });
    };

    initializeMsal();
  }, [navigate]);

  // Perform navigation after authentication is complete
  useEffect(() => {
    if (isAuthenticated) {
      const redirectPath = sessionStorage.getItem("postLoginRedirect");
      if (redirectPath) {
        navigate(redirectPath, { replace: true });
        sessionStorage.removeItem("postLoginRedirect");
      }
    }
  }, [isAuthenticated, navigate]);

  if (!msalInstance) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <Provider store={store}>
        <MsalProvider instance={msalInstance} >
          <Layout />
        </MsalProvider >
      </Provider>
    </React.Fragment>
  );
}

export default App;
function getAccountFromActiveAccountId(instance: PublicClientApplication) {
  const activeAccountId = localStorage.getItem('activeAccountId');
  if (!activeAccountId) return null;
  const accounts = instance.getAllAccounts();
  return accounts.find(acc => acc.homeAccountId === activeAccountId) || null;
}

